// Token Storage Utility
export const saveToken = (token) => {
  localStorage.setItem('jwtToken', token);
};

export const getStoredToken = () => {
  return localStorage.getItem('jwtToken');
};

export const removeToken = () => {
  localStorage.removeItem('jwtToken');
};
